import { withInstall } from '@pc-fx-framework/utils/with-install'
import PageTable from './src/page-table.vue'

export const FxPageTable = withInstall(PageTable)
export default FxPageTable

export * from './src/types'
